module.exports = __webpack_public_path__ + "img/Bunny-Man.6b16c8e4.png";